import {
    AccountCircle,
    BugReport,
    BugReportOutlined,
    Campaign,
    Category,
    ContactSupport,
    CorporateFare,
    CurrencyRupee,
    Dashboard,
    DocumentScannerRounded,
    Forum,
    Image,
    ImportantDevices,
    Key,
    LocalActivity,
    LocalLibrary,
    LocalLibraryOutlined,
    Newspaper,
    OndemandVideo,
    Pin,
    PsychologyAlt,
    QuestionAnswer,
    Schedule,
    Task,
    VerifiedUser,
    ViewInAr,
    VpnKey,
    Webhook,
    YouTube,
} from '@mui/icons-material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import FlagCircleIcon from '@mui/icons-material/FlagCircle';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import { Download, FileSlidersIcon, UsbIcon } from 'lucide-react';
const MenuOptions = [
    [
        {
            name: 'resources.dashboard.organization_dashboard',
            to: '/',
            icon: <Dashboard />,
            permission: 'DASHBOARD',
            children: [],
        },
    ],

    [
        {
            name: 'Organizations',
            icon: <CorporateFare />,
            children: [
                {
                    name: 'resources.organizations.name',
                    to: '/organizations',
                    icon: <CorporateFare />,
                    permission: 'ORGANIZATION',
                    children: [],
                },
                {
                    name: 'resources.organization_resources.name',
                    to: '/organization-resources',
                    icon: <CorporateFare />,
                    permission: 'ORGANIZATION_RESOURCE',
                    children: [],
                },
            ],
        },
    ],
    [
        {
            name: 'Cron Jobs',
            to: '/cron-jobs',
            icon: <Schedule />,
            permission: 'CRON_JOB',
            children: [],
        },
    ],

    [
        {
            name: 'User Management',
            icon: <AccountCircle />,
            children: [
                {
                    name: 'resources.users.name',
                    to: '/users',
                    permission: 'USERS',
                    icon: <AccountCircle />,
                    children: [],
                },
                {
                    name: 'Deleted Users',
                    to: '/deleted_users',
                    permission: 'DELETED_USERS',
                    icon: <AccountCircle />,
                    children: [],
                },
                // {
                //     name: 'resources.user_permissions.name',
                //     to: '/acl_user_permissions',
                //     icon: <Key />,
                //     permission: 'USERS',
                //     children: [],
                // },
                {
                    name: 'resources.otps.name',
                    to: '/otps',
                    permission: 'USERS_OTP',
                    icon: <Pin />,
                    children: [],
                },
            ],
        },
    ],

    [
        {
            name: 'Access Control',
            icon: <PictureAsPdfIcon />,
            children: [
                {
                    name: 'Role',
                    to: '/roles',
                    permission: 'ACCESS_CONTROL',
                    // permission: "VIDEO",
                    icon: <PictureAsPdfIcon />,
                    children: [],
                },
            ],
        },
    ],

    [
        {
            name: 'Study',
            icon: <LocalLibrary />,
            children: [
                {
                    name: 'resources.programs.name',
                    to: '/programs',
                    permission: 'PROGRAM',
                    icon: <ViewInAr />,
                    children: [],
                },
                {
                    name: 'resources.test_serieses.name',
                    permission: 'PROGRAM',
                    to: '/test-series',
                    icon: <DocumentScannerRounded />,
                    children: [],
                },
                {
                    name: 'Exercise',
                    permission: 'PROGRAM',
                    to: '/exercises',
                    icon: <FileSlidersIcon />,
                    children: [],
                },
                {
                    name: 'resources.batch_templates.name',
                    permission: 'BATCH_TAMPLATE',
                    to: '/batch-templates',
                    icon: <LocalLibraryOutlined />,
                    children: [],
                },
                {
                    name: 'resources.batches.name',
                    to: '/batches',
                    permission: 'BATCH',
                    icon: <LocalLibrary />,
                    children: [],
                },
            ],
        },
    ],

    [
        {
            name: 'Question Bank',
            icon: <Newspaper />,
            children: [
                {
                    name: 'Question Bank',
                    to: '/questions_bank',
                    permission: 'QUESTION_BANK',
                    icon: <Newspaper />,
                    children: [],
                },
                {
                    name: 'MetaData',
                    to: '/metadata',
                    permission: '',
                    icon: <Newspaper />,
                    children: [],
                },
            ],
        },
    ],

    [
        {
            name: 'Video Repository',
            icon: <OndemandVideo />,
            children: [
                {
                    name: 'Video Categories',
                    to: '/video-subjects',
                    permission: 'VIDEO_SUBJECT',
                    icon: <Webhook />,
                    children: [],
                },
                {
                    name: 'resources.videos.name',
                    to: '/videos',
                    permission: 'VIDEO',
                    icon: <Webhook />,
                    children: [],
                },
                {
                    name: 'Demo Video Category',
                    to: '/demo-video-categories',
                    permission: 'DEMO_VIDEOS',
                    icon: <OndemandVideo />,
                    children: [],
                },
                {
                    name: 'Demo videos',
                    to: '/demo-videos',
                    permission: 'DEMO_VIDEOS',
                    icon: <OndemandVideo />,
                    children: [],
                },
                {
                    name: 'Live channels',
                    to: '/live_channels',
                    permission: 'LIVE_CLASS',
                    icon: <OndemandVideo />,
                    children: [],
                },
            ],
        },
    ],

    [
        {
            name: 'PDF Repository',
            icon: <PictureAsPdfIcon />,
            children: [
                {
                    name: 'PDF Categories',
                    to: '/pdf-categories',
                    permission: 'PDF_CATEGORIES',
                    icon: <PictureAsPdfIcon />,
                    children: [],
                },
                {
                    name: 'PDF',
                    to: '/pdfs',
                    permission: 'PDF',
                    icon: <PictureAsPdfIcon />,
                    children: [],
                },
            ],
        },
    ],

    [
        {
            name: 'Broadcast',
            icon: <Campaign />,
            children: [
                {
                    name: 'Segments',
                    to: '/segmentations',
                    permission: 'SEGMENTS',
                    icon: <Campaign />,
                    children: [],
                },
                {
                    name: 'Campaigns',
                    to: '/campaigns',
                    permission: 'CAMPAIGNS',
                    icon: <Campaign />,
                    children: [],
                },
            ],
        },
    ],

    [
        {
            name: 'Ecom',
            icon: <CurrencyRupee />,
            children: [
                {
                    name: 'resources.coupons.name',
                    to: '/ecom-coupons',
                    permission: 'COUPONS',
                    icon: <LocalActivity />,
                    children: [],
                },
                {
                    name: 'resources.orders.name',
                    to: '/ecom-orders',
                    permission: 'ORDER',
                    icon: <CurrencyRupee />,
                    children: [],
                },
                {
                    name: 'resources.categories.name',
                    to: '/ecom_categories',
                    permission: 'ECOM_CATEGORIES',
                    icon: <Category />,
                    children: [],
                },
            ],
        },
    ],

    [
        {
            name: 'Blogs',
            to: 'https://blogs.kaksya.in/ghost/#/signin',
            permission: 'BLOGS',
            icon: <Newspaper />,
            sideIcon: <ArrowOutwardIcon sx={{ fontSize: 18 }} />,
            children: [],
            openInNewTab: true,
        },
    ],

    [
        {
            name: 'Podcast',
            icon: <Campaign />,
            children: [
                {
                    name: 'resources.podcast_topics.name',
                    to: '/podcast-topics',
                    permission: 'PODCAST',
                    icon: <Campaign />,
                    children: [],
                },
                {
                    name: 'resources.podcasts.name',
                    to: '/podcasts',
                    permission: 'PODCAST',
                    icon: <Campaign />,
                    children: [],
                },
            ],
        },
    ],

    [
        {
            name: 'Banners',
            icon: <Image />,
            children: [
                {
                    name: 'resources.banner_categories.name',
                    to: '/banner-categories',
                    permission: 'BANNERS',
                    icon: <Image />,
                    children: [],
                },
                {
                    name: 'resources.banners.name',
                    to: '/banners',
                    permission: 'BANNERS',
                    icon: <Image />,
                    children: [],
                },
            ],
        },
    ],

    [
        {
            name: 'FAQs',
            icon: <Image />,
            children: [
                {
                    name: 'resources.faq_categories.name',
                    to: '/faq-categories',
                    permission: 'FAQS',
                    icon: <QuestionAnswer />,
                    children: [],
                },
                {
                    name: 'resources.faqs.name',
                    to: '/faqs',
                    permission: 'FAQS',
                    icon: <QuestionAnswer />,
                    children: [],
                },
            ],
        },
    ],

    [
        {
            name: 'Testimonials',
            icon: <Image />,
            children: [
                {
                    name: 'Testimonial Categories',
                    to: '/testimonial-category',
                    permission: 'TESTIMONIALS',
                    icon: <VerifiedUser />,
                    children: [],
                },
                {
                    name: 'Testimonials',
                    to: '/testimonials',
                    permission: 'TESTIMONIALS',
                    icon: <VerifiedUser />,
                    children: [],
                },
            ],
        },
    ],

    // [
    //   {
    //     name: "Doubt and Queries",
    //     icon: <ContactSupport />,
    //     children: [
    //       {
    //         name: "resources.doubts.name",
    //         to: "/doubts",
    //         permission: "doubts",
    //         icon: <ContactSupport />,
    //         children: [],
    //       },
    //       {
    //         name: "resources.queries.name",
    //         to: "/queries",
    //         icon: <PsychologyAlt />,
    //         children: [],
    //       },
    //     ],
    //   },
    // ],

    [
        {
            name: 'Issues',
            icon: <BugReportOutlined />,
            children: [
                {
                    name: 'resources.issue_topics.name',
                    to: '/issue-topics',
                    permission: 'ISSUE_TOPICS',
                    icon: <BugReportOutlined />,
                    children: [],
                },

                {
                    name: 'resources.issues.name',
                    permission: 'ISSUE',
                    to: '/issues',
                    icon: <BugReport />,
                    children: [],
                },
            ],
        },
    ],

    [
        {
            name: 'Reports',
            // to: "/report/signups",
            // permission: "REPORT_SIGNUP",
            icon: <FlagCircleIcon />,
            children: [
                {
                    name: 'resources.reports.signups',
                    to: '/report/signups',
                    permission: 'REPORTS',
                    icon: <ReportProblemIcon />,
                    children: [],
                },
                {
                    name: 'resources.reports.tests',
                    to: '/report/tests',
                    permission: 'REPORTS',
                    icon: <ReportProblemIcon />,
                    children: [],
                },
                // {
                //     name: 'resources.reports.store_items',
                //     to: '/report/store_items',
                //     permission: 'REPORTS',
                //     icon: <ReportProblemIcon />,
                //     children: [],
                // },
                {
                    name: 'resources.reports.orders',
                    to: '/report/orders',
                    permission: 'REPORTS',
                    icon: <ReportProblemIcon />,
                    children: [],
                },
                {
                    name: 'resources.reports.batch_students',
                    to: '/report/batch_students',
                    permission: 'REPORTS',
                    icon: <ReportProblemIcon />,
                    children: [],
                },
                // {
                //     name: 'resources.reports.application_users',
                //     to: '/report/application_users',
                //     permission: 'REPORTS',
                //     icon: <ReportProblemIcon />,
                //     children: [],
                // },
            ],
        },
    ],
    [
        {
            name: 'Pendrive Courses',
            icon: <UsbIcon />,
            children: [
                {
                    name: 'Activation Codes',
                    to: '/pendrive/activation-codes',
                    permission: 'ACTIVATION_CODES',
                    icon: <VpnKey />,
                    children: [],
                },
            ],
        },
    ],
    [
        {
            name: 'Bulk Upload (Beta)',
            to: '/bulk-uploads',
            permission: 'DASHBOARD',
            icon: <Download />,
            children: [],
        },
    ],
];
export default MenuOptions;
